export default __webpack_public_path__ + "static/media/spiral.6a2a22a5.png";